import { BaseApi } from './base.api.js';

export class ExplicitConsentReasonApi extends BaseApi {
    constructor(client) {
        super(client, '/explicit-consent-reason');
    }
}
